module.exports = __webpack_public_path__ + "static/media/_CIB Egypt_.ac46bfcd.jpg";